<div class="flex gap-3 rounded-lg border border-slate-100 bg-slate-50 p-3">
  <div
    class="mt-0.5 inline-flex h-8 w-8 shrink-0 items-center justify-center rounded-full bg-white"
    [class.text-emerald-500]="call.call_type === 'in'"
    [class.text-sky-500]="call.call_type === 'out'"
  >
    <app-icon class="inline-flex !h-[18px] !w-[18px] items-center justify-center !text-[18px] !leading-[18px]">
      {{ call.call_type === 'in' ? 'call_received' : 'call_made' }}
    </app-icon>
  </div>
  <div class="min-w-0 flex-1">
    <div class="flex flex-wrap items-center justify-between gap-2">
      <div class="min-w-0">
        <div class="truncate text-sm font-semibold text-slate-800">{{ 'calls_tab' | translate }}</div>
        <div class="truncate text-xs font-medium text-slate-500">{{ call.phone || '-' }}</div>
      </div>
      <div class="flex shrink-0 items-center gap-1">
        <span class="text-xs text-slate-400">{{ event.created_at | date: 'dd MMM HH:mm' }}</span>
        <button
          type="button"
          class="flex h-6 w-6 items-center justify-center rounded text-slate-400 hover:bg-slate-100 hover:text-slate-600"
          [attr.aria-label]="'board_v3_calls_actions' | translate"
          [cdkMenuTriggerFor]="callActionsMenu"
        >
          <app-icon class="!h-4 !w-4 !text-[16px] !leading-4">more_vert</app-icon>
        </button>
      </div>
    </div>

    <div class="mt-1 flex flex-wrap items-center gap-3 text-xs text-slate-500">
      <span>{{ call.disposition || '-' }}</span>
      <span>{{ formatDuration(call.duration_ms) }}</span>
      @if (call.x_data?.employee_fio) {
        <span>{{ call.x_data.employee_fio }}</span>
      }
    </div>

    @if (call.recording_url) {
      <audio class="mt-2 w-full" controls [src]="call.recording_url"></audio>
    }

    @if (call.transcription || call.transcript_utterances?.length) {
      <div class="mt-2 flex items-start justify-between gap-2">
        @if (call.transcription) {
          <details class="min-w-0 flex-1">
            <summary class="cursor-pointer text-xs font-medium text-orange-600">
              {{ 'board_v3_calls_transcription' | translate }}
            </summary>
            <p class="m-0 mt-1 whitespace-pre-wrap text-xs leading-5 text-slate-600">{{ call.transcription }}</p>
          </details>
        }
        @if (call.transcript_utterances?.length) {
          <button
            type="button"
            class="flex shrink-0 items-center gap-1.5 rounded-lg! bg-white px-2.5 py-1.5 text-xs font-semibold text-orange-600 shadow-sm transition hover:bg-orange-50"
            (click)="openTranscript()"
          >
            <app-icon class="!h-4 !w-4 !text-[16px] !leading-none">forum</app-icon>
            {{ 'board_v3_calls_transcript_dialog' | translate }}
          </button>
        }
      </div>
    }
  </div>
</div>

<ng-template #callActionsMenu>
  <div cdkMenu class="min-w-40 rounded-xl border border-gray-100 bg-white p-1.5 shadow-lg">
    <button
      type="button"
      cdkMenuItem
      class="flex w-full items-center gap-2 rounded-lg px-3 py-2 text-left text-sm text-red-600 hover:bg-red-50"
      (click)="onDeleteClick()"
    >
      <app-icon class="!h-4 !w-4 !text-[16px] !leading-4 text-red-500">delete</app-icon>
      {{ 'delete' | translate }}
    </button>
  </div>
</ng-template>
